//$Id$
/**
 * @file utility-library
 * @version 1.0.0
 * @notes Deprecated Functions
 * trim(string) - Use javascript function string.trim()
 * split(string) - Use javascript function string.split(separator)
 * startsWith(string, prefix) - Use javascript function string.startsWith(searchString)
 * endsWith(string, suffix) - Use javascript function string.endsWith(searchString)
 * replaceAll(string, pattern, replacement) - Use javascript function string.replaceAll(pattern, replacement)
 * string.contains(searchvalue) - Use javascript function string.includes(searchvalue)
 */

/**
 * Replace string with matched string/pattern
 * @param {string} string original string
 * @param {string} replace pattern/string want to replace
 * @param {string} replacewith new string
 * @returns replaced string
 */
function replaceAll(string,replace,replacewith)
{
	string = string.replace(new RegExp(replace, 'g') , replacewith);
	return string;
}

/**
 * Removes special charecters from string
 * @param {string} str 
 * @returns new string after removed following characters ([#;?%+*~\'"!^$[\]()=>|\/@])
 */
function rmSplCharStr(str) 
{
    if (str)
    {
	    return str.replace(/([#;?%+*~\'"!^$[\]()=>|\/@])/g,'');      
    }
    return str;
}

/**
 * Removes special charecters defined in rmSplCharStr except @ 
 * @param {string} str 
 * @returns  new string after removed following characters ([#;?%*~\'"!^$[\]()=>|\/])
 */
function rmSplCharStrwithAt(str) 
{
    if (str)
    {
	    return str.replace(/([#;?%*~\'"!^$[\]()=>|\/])/g,'');      
    }
    return str;
}

/**
 * Check the value is boolean
 * @param {string} val 
 * @returns {boolean} Returns false if the value is one of it(false, no, 0, emptyspace). Otherwise true
 */
function stringToBoolean(val){
    if ("boolean" === (typeof val)){
        return val;
    }
    switch(val.toLowerCase()) {case "false": case "no": case "0": case "": return false; default: return true;} //no I18n
}

/**
 * Check the value is Decimal
 * @param {string} value value to be tested
 * @returns{boolean} Returns true if the given value is decimal. Otherwise false
 */
function isDecimal(value){
    const decimalRegex = /^(\d{0,14}\.)?\d{1,14}$/;
	if(value!="" && !decimalRegex.test(value)){
		return false;
	}		
	return true;
}

/**
 * Check wheter the value is an integer
 * @param {string} value value to be tested
 * @returns {boolean} Returns true if the given value is integer. Otherwise false
 */
function isNumericValue(value){
    const numberRegex = /^(\-?(\d{0,19}))$/;
	if(value!="" && !numberRegex.test(value)){
		return false;
	}		
	return true;
}

var startsWith=function(str,prefix)
{
	var preLen=prefix.length;
	var strLen=str.length;
	if(preLen>str.length) return false;
	return(str.substr(0,preLen)===prefix);
}

if (typeof String.prototype.contains != 'function'){
   
     /**
     * To determine the given value exists in the string
     * @function contains
     * @deprecated Use javascript function string.includes(searchvalue)
     * @param {string} str 
     * @returns Returns true if the given value exists. Otherwise false
     */
	String.prototype.contains = function (str){
		return this.indexOf(str) > -1;
	};
}

if (typeof String.prototype.toCamelCase != 'function'){
	/**
     * Convert the value into camel case value
     * @function toCamelCase
     * @param {string} str value
     * @returns {string} Converted value
     */
	String.prototype.toCamelCase = function(){
		var str = this.toLowerCase();
		return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
			return index == 0 ? letter.toUpperCase() : letter.toUpperCase();
		}).replace(/\s+/g, '');
	}
}

var endsWith=function(str,suffix)
{
	var sufLen=suffix.length;
	var strLen=str.length;
	if(sufLen>str.length) return false;
	return(str.substr(strLen-sufLen,sufLen)===suffix);
}

/**
 * Check the value is an object
 * @param {object} item value want to check
 * @returns {boolean} Returns true if is an object. Otherwise false
 */

function isObject(item) {
	return (item && typeof item === 'object' && !Array.isArray(item)); //NO I18N
}

/**
 * Deep copy an object from source object to target object
 * @param {object} target Target object
 * @param {object} source Source object
 * @returns Returns target object with source merged
 */
function mergeDeep(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
      Object.keys(source).forEach(key => {
        if (isObject(source[key]) && !isElement(source[key])) {
          if (!(key in target))
            Object.assign(output, { [key]: source[key] });
          else
            output[key] = mergeDeep(target[key], source[key]);
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }
    return output;
  }

function isElement(element) {
    return element instanceof Element || element instanceof HTMLDocument;  
}

/**
 * Perform deep comparison between two values, if they are equivalent
 * @param {*} objectOne 1st comparable value
 * @param {*} objectTwo 2nd comparable value
 * @returns {boolean} Retruns true if two values are equivalent.
 */
function areEqual(objectOne, objectTwo) {

	if (typeof objectOne !== typeof objectTwo) {
	  return false;
	}

	// Check if the objects are null or undefined
	if (!objectOne || !objectTwo) {
	  return objectOne === objectTwo;
	}

	// Check if the objects are arrays
	if (Array.isArray(objectOne) !== Array.isArray(objectTwo)) {
	  return false;
	}

	// Check the number of keys in the objects
	const objectOneKeys = Object.keys(objectOne);
	const objectTwoKeys = Object.keys(objectTwo);
	if (objectOneKeys.length !== objectTwoKeys.length) {
	  return false;
	}

	// Check each key-value pair in the objects
	for (var key in objectOne) {
		if (!objectTwo.hasOwnProperty(key)) {
		  return false;
		}

		// Recursively compare nested objects
		if (typeof objectOne[key] === 'object') {
		  if (!areEqual(objectOne[key], objectTwo[key])) {
			return false;
		  }
		} else {
		  if (objectOne[key] != objectTwo[key]) {
			return false;
		  }
		}
	}
	return true;
  }

/**
 * Check if the value is an empty object
 * @param {*} obj Value need to be checked
 * @returns {boolean} Returns true if the value is empty value, else false
 */
function isEmptyObject(obj) {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
}

/**
 * Clone the JSON value
 * @param {*} json Value need to be cloned
 * @returns Returns cloned value
 */
function cloneJSON(json) {
	return JSON.parse(JSON.stringify(json))
}
/**
 * Convert array to an object with mentioned key value as key
 * @param {*} data array 
 * @param {*} keyToLoop iterate over key in the array
 * @param {*} internalKeyValAsExternalKey value key for the convertion
 * @returns {object} Converted object
 */
function convertArrayWithIdRef(data, keyToLoop, internalKeyValAsExternalKey){
	let dataArray = getData(data, keyToLoop);
	let keyLen = dataArray.length;
	for(let index=0; index < keyLen; index++){
		let externalKey = dataArray[index][internalKeyValAsExternalKey];
		dataArray[externalKey] = dataArray[index];
		delete dataArray[index];
	}
}
function getData(data, keyToLoop){
	let retData = data;
	let keys = keyToLoop.split(".");
	for(let i=0; i < keys.length - 1; i++)
		retData = retData[keys[i]] || {};
	return Object.prototype.toString.call(retData[keys[keys.length - 1]]) === '[object Array]' ? retData[keys[keys.length - 1]] : [retData[keys[keys.length - 1]]]
}

/**
 * Find values present in first array which is not available in second array
 * @param {*} a first array
 * @param {*} b second array
 * @returns Returns Extra values in first array
 */
//Wow!! Such a simple JS code
//Please refer https://stackoverflow.com/questions/1187518/how-to-get-the-difference-between-two-arrays-in-javascript for ES7 including so many ways
function arrayDiff(a, b) {
    return a.filter(function(i) {return b.indexOf(i) < 0;});
}
function getCdnUrl(type,path){
	var fileName=fingerPrintJson[path];
	var domain='';

	if(fileName===null || fileName===undefined)
	{
		fileName=path;
	}
    if(type=='css'){
    	domain=Utils.cssCdnURL;
    }
    else if(type=='js'){
    	domain=Utils.jsCdnURL;
    }
    else{
    	domain=Utils.imgCdnURL;
    }
    if(domain===null || domain===undefined || domain==""){
    	fileName=path;
    	domain="../../";
    }
    var resourcePath=domain+fileName;
	return resourcePath;
}
/***Deprecated Functions */

/**
 * Wrapper for string trim function - Use javascript function string.trim()
 * @deprecated
 * @param {string} str string with whitespaces 
 * @returns whitespace removed string
 */
function trim(str) {	
	return str.trim();
}
/**
 * Split value if contains space or comma
 * @param {string} val 
 * @returns returns an array 
 */
function split( val ) {
	return val.split( /,\s*/ );
}

/*TEMP - REMOVE isEmptyArray method IT SIRAJ */
function isEmptyArray(arr){
	if(Array.isArray(arr) && arr.length == 0){
		return true;
	}
	return false;
}

/**
 * Converts keys of an object from snake_case to camelCase.
 * Optionally converts nested keys based on the 'deepConvert' parameter.
 *
 * @param {object|Array} obj The object or array to convert.
 * @param {boolean} [deepConvert=false] If true, recursively converts keys in nested objects and arrays.
 * @returns {object|Array} A new object or array with keys converted to camelCase.
 */
function convertKeysToCamelCase(obj, deepConvert = false) {
	if (typeof obj !== 'object' || obj === null) {
		return obj;
	}

	if (Array.isArray(obj)) {
		return obj.map(item => deepConvert ? convertKeysToCamelCase(item, deepConvert) : item);
	}

	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const camelCaseKey = snakeToCamel(key);

			if (deepConvert) {
				obj[camelCaseKey] = convertKeysToCamelCase(obj[key], deepConvert);
			} else {
				obj[camelCaseKey] = obj[key];
			}
            if (key !== camelCaseKey) {
			    delete obj[key];
			}
		}
	}

	return obj;
}


function snakeToCamel(snakeCaseString) {
	return snakeCaseString.replace(/_([a-z])/g, (match, char) => char.toUpperCase());
}
function isEmptyObjectOrArray(obj) {
	return obj == null || (typeof obj === "string" ? obj.trim().length === 0 : Array.isArray(obj) ? obj.length === 0 : typeof obj === "object" && Object.keys(obj).length === 0); //no i18n
}
Object.assign(window, {replaceAll, rmSplCharStr, rmSplCharStrwithAt, stringToBoolean, isDecimal, isNumericValue, startsWith, endsWith, isObject, mergeDeep,
    isElement, areEqual, isEmptyObject, cloneJSON, convertArrayWithIdRef, getData, arrayDiff, trim, split,getCdnUrl,isEmptyArray,convertKeysToCamelCase,isEmptyObjectOrArray});
